'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutPropertiesLoose = require('@babel/runtime/helpers/objectWithoutPropertiesLoose');
var _taggedTemplateLiteralLoose = require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
var React = require('react');
var bumbag = require('bumbag');
var faComments = require('@fortawesome/pro-solid-svg-icons/faComments');
var faBook = require('@fortawesome/pro-solid-svg-icons/faBook');
var faSignOutAlt = require('@fortawesome/pro-solid-svg-icons/faSignOutAlt');
var faUser = require('@fortawesome/pro-solid-svg-icons/faUser');
var faCaretDown = require('@fortawesome/pro-solid-svg-icons/faCaretDown');
var faQuestionCircle = require('@fortawesome/pro-solid-svg-icons/faQuestionCircle');
var intercom = require('@medipass/utils/intercom');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var sdk = require('@medipass/web-sdk');
require('../../state.js');
require('@babel/runtime/helpers/defineProperty');
require('query-string');
var reactRouterDom = require('react-router-dom');
var constate = require('constate');
require('../../contexts/DataTableContext.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutPropertiesLoose__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutPropertiesLoose);
var _taggedTemplateLiteralLoose__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteralLoose);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var intercom__namespace = /*#__PURE__*/_interopNamespace(intercom);
var sdk__default = /*#__PURE__*/_interopDefaultLegacy(sdk);

var _excluded = ["accountPath", "onLogout", "isHorizontal", "userImage", "username"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var Wrapper = bumbag.styled(bumbag.Navigation)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose__default["default"](["\n  background-color: white;\n  ", ";\n\n  ", ";\n"])), function (props) {
  return (// @ts-expect-error TS(2339): Property 'isHorizontal' does not exist on type 'Pi... Remove this comment to see the full error message
    props.isHorizontal ? 'height: 100%' : 'width: 100%'
  );
}, function (props) {
  return (// @ts-expect-error TS(2339): Property 'isHorizontal' does not exist on type 'Pi... Remove this comment to see the full error message
    !props.isHorizontal && bumbag.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose__default["default"](["\n      padding: 1rem 0;\n    "])))
  );
});
var ListItem = bumbag.styled(bumbag.List.Item)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose__default["default"](["\n  margin: 0 !important;\n  ", ";\n\n  & > div {\n    ", ";\n  }\n"])), function (props) {
  return (// @ts-expect-error TS(2339): Property 'isHorizontal' does not exist on type 'Pi... Remove this comment to see the full error message
    props.isHorizontal ? 'height: 100%' : 'width: 100%'
  );
}, function (props) {
  return (// @ts-expect-error TS(2339): Property 'isHorizontal' does not exist on type 'Pi... Remove this comment to see the full error message
    props.isHorizontal ? 'height: 100%' : 'width: 100%'
  );
}); // @ts-expect-error TS(2769): No overload matches this call.

var MenuButton = bumbag.styled(bumbag.Button)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose__default["default"](["\n  align-items: center;\n  border: none;\n  border-left: 1px solid ", ";\n  color: ", ";\n  cursor: pointer;\n  display: flex;\n  font-weight: ", ";\n  min-height: 50px;\n  padding: 0 ", "rem;\n  text-transform: uppercase;\n\n  ", ";\n\n  &&&:hover {\n    background: ", ";\n    color: ", ";\n  }\n\n  &&&:hover:focus {\n    background: ", ";\n    color: ", ";\n  }\n\n  &&&:focus {\n    background: ", ";\n    border: none;\n    border-left: 1px solid ", ";\n    color: ", ";\n    outline: none;\n  }\n"])), bumbag.palette('white900'), bumbag.palette('tertiary'), bumbag.fontWeight('semibold'), bumbag.space(4), function (props) {
  return (// @ts-expect-error TS(2339): Property 'isHorizontal' does not exist on type 'Pi... Remove this comment to see the full error message
    props.isHorizontal ? 'height: 100%' : 'width: 100%'
  );
}, bumbag.palette('white700'), bumbag.palette('text'), bumbag.palette('white900'), bumbag.palette('text'), bumbag.palette('white700'), bumbag.palette('white900'), bumbag.palette('text'));
var MenuItem = bumbag.styled(bumbag.DropdownMenu.Item)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose__default["default"](["\n  color: ", ";\n  text-transform: uppercase;\n\n  & i {\n    display: inline-flex;\n    justify-content: center;\n    width: 20px;\n  }\n"])), bumbag.palette('tertiary'));
var guideLinks = {
  provider: 'http://help.medipass.com.au'
};

function UserMenu(props) {
  var accountPath = props.accountPath,
      onLogout = props.onLogout,
      isHorizontal = props.isHorizontal,
      userImage = props.userImage,
      username = props.username,
      restProps = _objectWithoutPropertiesLoose__default["default"](props, _excluded);

  function handleForceRefresh() {
    if (typeof window !== 'undefined') {
      // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
      window.location.reload(true);
    }
  }

  return (
    /*#__PURE__*/
    // @ts-expect-error TS(2322): Type '{ children: Element; isHorizontal: boolean; ... Remove this comment to see the full error message
    React__default["default"].createElement(Wrapper, _extends__default["default"]({
      isHorizontal: isHorizontal
    }, restProps), /*#__PURE__*/React__default["default"].createElement(bumbag.List, {
      display: isHorizontal ? 'flex' : undefined,
      isHorizontal: isHorizontal,
      height: "100%"
    }, /*#__PURE__*/React__default["default"].createElement(ListItem, {
      isHorizontal: isHorizontal
    }, /*#__PURE__*/React__default["default"].createElement(bumbag.DropdownMenu // @ts-expect-error TS(2322): Type '{ children: Element; placement: string; menu... Remove this comment to see the full error message
    , {
      placement: "bottom-end",
      menu: /*#__PURE__*/React__default["default"].createElement(bumbag.DropdownMenu.Group, null, /*#__PURE__*/React__default["default"].createElement(MenuItem, {
        onClick: intercom__namespace.showNewMessage
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "flex items-center whitespace-nowrap"
      }, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
        icon: faComments.faComments,
        className: "mr-2"
      }), /*#__PURE__*/React__default["default"].createElement("span", null, "Chat to us"))), /*#__PURE__*/React__default["default"].createElement(constate.Container, {
        context: "app"
      }, function (_ref) {
        var type = _ref.type;
        return (// @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          guideLinks[type] ? /*#__PURE__*/React__default["default"].createElement(MenuItem, {
            use: "a",
            color: "tertiary" // @ts-expect-error TS(2322): Type '{ children: (string | Element)[]; use: strin... Remove this comment to see the full error message
            ,
            href: guideLinks[type],
            target: "_blank",
            rel: "noopener noreferrer"
          }, /*#__PURE__*/React__default["default"].createElement("div", {
            className: "flex items-center whitespace-nowrap"
          }, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
            icon: faBook.faBook,
            className: "mr-2"
          }), /*#__PURE__*/React__default["default"].createElement("span", null, "Guides"))) : null
        );
      }), /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
        fontSize: "100",
        paddingLeft: "major-1",
        paddingRight: "major-1"
      }, /*#__PURE__*/React__default["default"].createElement(bumbag.Text, null, "Version: ", process.env.NODE_ENV === 'test' ? '1.0.0' : sdk__default["default"].versions.getCurrentAppVersion())), /*#__PURE__*/React__default["default"].createElement(bumbag.Button, {
        palette: "tertiary",
        variant: "link",
        size: "small",
        onClick: handleForceRefresh
      }, "Force refresh"))
    }, /*#__PURE__*/React__default["default"].createElement(MenuButton, {
      isHorizontal: isHorizontal
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "flex items-center justify-center whitespace-nowrap"
    }, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
      icon: faQuestionCircle.faQuestionCircle,
      className: "mr-2"
    }), /*#__PURE__*/React__default["default"].createElement("span", null, "HELP"), /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
      icon: faCaretDown.faCaretDown,
      className: "ml-2"
    }))))), /*#__PURE__*/React__default["default"].createElement(ListItem, {
      isHorizontal: isHorizontal
    }, /*#__PURE__*/React__default["default"].createElement(bumbag.DropdownMenu, {
      menu: /*#__PURE__*/React__default["default"].createElement(bumbag.DropdownMenu.Group, null, /*#__PURE__*/React__default["default"].createElement(MenuItem, {
        use: reactRouterDom.Link,
        color: "tertiary",
        to: accountPath
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "flex items-center whitespace-nowrap"
      }, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
        icon: faUser.faUser,
        className: "mr-2"
      }), /*#__PURE__*/React__default["default"].createElement("span", null, "Tyro Health Account"))), /*#__PURE__*/React__default["default"].createElement(MenuItem, {
        onClick: onLogout
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "flex items-center whitespace-nowrap"
      }, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
        icon: faSignOutAlt.faSignOutAlt,
        className: "mr-2"
      }), /*#__PURE__*/React__default["default"].createElement("span", null, "Logout"))))
    }, /*#__PURE__*/React__default["default"].createElement(MenuButton, {
      isHorizontal: isHorizontal
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "flex items-center justify-center whitespace-nowrap"
    }, userImage ? /*#__PURE__*/React__default["default"].createElement("img", {
      src: userImage,
      className: "mr-3 h-[1.87rem] w-[1.87rem] rounded-full object-cover",
      alt: "User avatar"
    }) : /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
      icon: faUser.faUser,
      className: "mr-2"
    }), /*#__PURE__*/React__default["default"].createElement("span", null, username), /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
      icon: faCaretDown.faCaretDown,
      className: "ml-2"
    })))))))
  );
}

UserMenu.defaultProps = {
  accountPath: '/account',
  isHorizontal: true,
  userImage: undefined,
  username: 'Tyro Health User'
};

exports["default"] = UserMenu;
